import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { applyUpdate, useUpdateReady } from '@/lib/pwa';

/** Segundos antes de actualizar solo (fuera de un partido). */
const AUTO_SECONDS = 8;

/**
 * Aviso «Nueva versión disponible».
 *  - Fuera de un partido: se actualiza solo a los 8 s (o al pulsar «Actualizar»; «Más tarde» lo
 *    deja para la próxima vez que se abra la app).
 *  - En un partido: solo avisa; se instala al salir del partido (nunca a mitad de una jugada),
 *    salvo que el jugador pulse «Actualizar».
 */
export const UpdateNotice = () => {
  const ready = useUpdateReady();
  const { pathname } = useLocation();
  const inMatch = pathname.startsWith('/match/');
  const [later, setLater] = useState(false);
  const [left, setLeft] = useState(AUTO_SECONDS);

  useEffect(() => {
    if (!ready || inMatch || later) return;
    setLeft(AUTO_SECONDS);
    const t = setInterval(() => setLeft((s) => s - 1), 1000);
    return () => clearInterval(t);
  }, [ready, inMatch, later]);
  useEffect(() => {
    if (ready && !inMatch && !later && left <= 0) applyUpdate();
  }, [ready, inMatch, later, left]);

  if (!ready || later) return null;
  return (
    <div role="status" data-testid="update-notice" className="pointer-events-none fixed inset-x-0 bottom-3 z-[70] flex justify-center px-3">
      <div className="pointer-events-auto flex max-w-md flex-wrap items-center gap-2 rounded-xl border border-accent-500/40 bg-ink-900/95 px-3 py-2 text-xs text-slate-100 shadow-xl backdrop-blur">
        <span>
          ✨ Nueva versión disponible
          {inMatch ? ' · se instalará al terminar el partido' : ` · actualizando en ${Math.max(0, left)} s`}
        </span>
        <button type="button" onClick={applyUpdate} className="btn-primary h-7 px-3 text-xs">
          Actualizar
        </button>
        {!inMatch && (
          <button type="button" onClick={() => setLater(true)} className="btn-ghost h-7 px-3 text-xs">
            Más tarde
          </button>
        )}
      </div>
    </div>
  );
};
